/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/ejemplar";
        var params = {
            base: base,
            baseUrl: "/:edicionId/ejemplar",
            templateUrlBase: "app/admin/ejemplar/ejemplar",
            controller: 'EjemplarAdminController',
            controllerForm: 'EjemplarFormAdminController',
            translateBase: "admin.ejemplar.",
            parent: "admin/edicion"
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']

            },
            resolve: {
                /* @ngInject */
                edicion: function ($stateParams, Edicion) {
                    console.log("!!!Cargando la edicion!!!");
                    return Edicion.getNombre({id: $stateParams.edicionId}).$promise;
                }
            },
            ncyBreadcrumb: {
                parent: "admin/edicion/list"
            }
        });

        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1'
            }
        });

        var resolve = {
            /* @ngInject */
            encuadernaciones: function (EnumService) {
                return EnumService.get("encuadernacion");
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Ejemplar, $stateParams) {
                    var ejemplar = new Ejemplar();
                    ejemplar.edicion = {id: $stateParams.edicionId};
                    return ejemplar;
                }
            })
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Ejemplar, $stateParams) {
                    return Ejemplar.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
